import { createApiSlice } from "@common";
import {
    CRUD_INTEGRATION_MASTER,
    CRUD_INTEGRATION_MASTER_BY_ASSET_TYPE,
    GET_TAG_INTEGRATION_CONNECTION_BY_MASTER,
    TAG_INTEGRATION_CONNECTION
} from "@routes";

// Define the API config array
const apiConfig = [
    {
        name: "addIntegationMaster",
        method: "post",
        url: CRUD_INTEGRATION_MASTER,
        stateKey: "message",
    },
    {
        name: "getIntegationMasterByAssetType",
        method: "get",
        url: CRUD_INTEGRATION_MASTER_BY_ASSET_TYPE,
        stateKey: "data",
    },
    {
        name: "updateIntegationMaster",
        method: "put",
        url: CRUD_INTEGRATION_MASTER,
        stateKey: "message",
    },
    {
        name: "deleteIntegationMaster",
        method: "delete",
        url: CRUD_INTEGRATION_MASTER,
        stateKey: "message",
    },
    {
        name: "getTaggedIntegrationById",
        method: "get",
        url: GET_TAG_INTEGRATION_CONNECTION_BY_MASTER,
        stateKey: "tagDetailData",
    },
    {
        name: "tagToIntegration",
        method: "post",
        url: TAG_INTEGRATION_CONNECTION,
        stateKey: "message",
    },
    {
        name: "deleteTaggedIntegration",
        method: "delete",
        url: TAG_INTEGRATION_CONNECTION,
        stateKey: "message",
    },
];

// Define custom reducers and their initial state
const customReducers = {
    initialState: {
        additionalData: [],
        tagDetailData: [],
        details: [],
    },
    reducers: {
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
    },
    extraReducers: {
        // Example of custom extra reducer
        someCustomAction: (state, action) => {
            // Custom reducer logic
        },
    },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
    "integrationMaster",
    apiConfig,
    customReducers,
);
const integationMasterSlice = slice;
// Export the slice's reducer
export default integationMasterSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
    addIntegationMaster,
    getIntegationMasterByAssetType,
    updateIntegationMaster,
    deleteIntegationMaster,
    getTaggedIntegrationById,
    tagToIntegration,
    deleteTaggedIntegration,
} = thunks;

// Destructure and export actions
export const { rowSelect, } =
    actions;
